import React from "react";
import { RightBtn } from "../utils/icons";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
function Events({ heading, title, mapNum, cond }) {
  const newDate = new Date().toISOString().split("T")[0];
  dayjs.extend(utc);
  const filterCalenderDetails = useSelector(
    (state) => state.user.calenderDetails
  ).filter(
    (data) => data.EventDate.toLocaleString("en-US").split("T")[0] === newDate
  );
  const CalenderDetails = useSelector((state) => state.user.calenderDetails);
  const conditionalData = filterCalenderDetails.length
    ? filterCalenderDetails
    : CalenderDetails;

  return (
    <div className="space-y-3 w-full">
      <div>
        <h1 className="font-semibold">
          {filterCalenderDetails?.length ? "Today Event" : "No Event Today"}
        </h1>
        <p>{!filterCalenderDetails?.length && "Upcoming Events"}</p>
      </div>
      <div className={`max-h-[150px] ${cond && "overflow-y-scroll"} space-y-2`}>
        {conditionalData?.map((items, i) => {
          return (
            <div
              key={i}
              className="mr-5 flex justify-between py-2 px-5 bg-white items-center rounded-3xl"
            >
              <div>
                <h1 className="font-semibold">{items.Title}</h1>
                <p>
                  From
                  <span className="font-semibold">
                    {" " + dayjs(items.StartTime).utc().format("HH:mm") + " "}
                  </span>
                  To
                  <span className="font-semibold">
                    {" " + dayjs(items.EndTime).utc().format("HH:mm")}
                  </span>
                </p>
              </div>
              <RightBtn />
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Events;
